
export const NoAcceso = ()=>(
    <div><p style={{color:'red'}}>NO TIENE ACCESO</p></div>
)